import { render, staticRenderFns } from "./phoneField.vue?vue&type=template&id=64db9f1f&"
import script from "./phoneField.vue?vue&type=script&lang=js&"
export * from "./phoneField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports